export const getDigitsFromString = (value?: string) => {
  if (!value) return undefined
  return value.replace(/\D/g, '')
}
